import { Moment } from 'moment'

export const transformPeriod = (datePicked: Moment[]) => {
  if (!datePicked || datePicked?.length !== 2) return ['monthly', 'quarterly']

  const dayDifference: number = datePicked[1].diff(datePicked[0], 'days')
  let period = []

  if (dayDifference < 16) period.push('daily')
  if (Math.floor(dayDifference / 7) < 16 && dayDifference > 7)
    period.push('weekly')
  if (Math.floor(dayDifference / 30) < 16 && dayDifference > 30)
    period.push('monthly')
  if (Math.floor(dayDifference / 90) < 16 && dayDifference > 90)
    period.push('quarterly')
  if (Math.floor(dayDifference / 365) < 16 && dayDifference > 365)
    period.push('yearly')

  return period
}
